import React, { Component, ReactNode } from 'react';
import { logReactError } from './logging/logs';
import i18n from './i18n';

export class ErrorBoundary extends Component<
    {
        description?: string;
        fallback?: ReactNode;
        children?: ReactNode;
        level?: string;
    },
    { hasError: boolean }
> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        logReactError(error, info, this.props.description, this.props.level);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback || this.props.fallback === null) {
                return this.props.fallback;
            }

            return <div>{i18n('react.client.error')}</div>;
        }
        return this.props.children;
    }
}
